import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea898fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "qty-control-bar",
  elevation: "5"
}
const _hoisted_2 = { class: "qty-control-input-group" }
const _hoisted_3 = {
  key: 0,
  class: "qty-total text-grey"
}
const _hoisted_4 = {
  style: {"white-space":"nowrap"},
  class: "text-grey"
}
const _hoisted_5 = { style: {"font-weight":"400"} }
const _hoisted_6 = { class: "qty-control-action-container" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-1"
}

import {parseGermanFloat} from '@/util';
import {PropType, computed, ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QtyControl',
  props: {
  modelValue: {
    type: Number,
    required: false,
    default: null,
  },
  max: {
    type: Number,
    required: false,
    default: null,
  },
  qtyTotal: {
    type: Number,
    required: false,
    default: null,
  },
  unit: {
    type: String,
    required: true,
  },
  spareQtys: {
    type: Array as PropType<Array<string | number>>,
    required: false,
    default: () => [],
  },
  ean: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  consistsOf: {
    type: String,
    required: false,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
  noZero: {
    type: Boolean,
    required: false,
    default: false,
  },
  allowOvershoot: {
    type: Boolean,
    default: false,
  },
},
  emits: {
  'update:modelValue': (value: number) => typeof value === 'number',
},
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const rounded = ref(true);
const inFocus = ref(false);

const emits = __emit;

const internalValue = computed({
  get() {
    return props.modelValue;
  },
  set(newVal: number) {
    if (props.readonly) return;
    emits('update:modelValue', parseGermanFloat(newVal));
  },
});
const internalValueDisplay = computed({
  get() {
    return Math.floor(props.modelValue);
  },
  set(newVal: number | string) {
    internalValue.value = parseGermanFloat(newVal);
  },
});
const consistsOfDisplayed = computed(() => {
  return props.consistsOf ? `Inhalt: ${props.consistsOf}` : '';
});
const completed = computed(() => {
  return props.modelValue >= props.max;
});

const canIncrease = computed(() => {
  if (props.readonly) return false;
  return props.modelValue < props.max || props.allowOvershoot;
});

const spareQtysMessages = computed(() => {
  if (props.spareQtys.length > 0) return [' '];
  return [];
});

const ruleOk = (val: string | number): string | boolean => {
  val = parseGermanFloat(val);

  if (val > props.max && !props.allowOvershoot) return 'zu groß';
  if (val < 0) return 'zu klein';
  if (props.noZero && val === 0) return '0 ist nicht erlaubt';

  return true;
};
const color = computed(() => {
  if (props.max == 0) return undefined;
  if (internalValue.value === props.max) return 'success';
  if (internalValue.value > props.max) return 'warning';

  return undefined;
});

__expose({
  rounded,
  inFocus,
  internalValue,
  internalValueDisplay,
  consistsOfDisplayed,
  completed,
  spareQtysMessages,
  canIncrease,
  ruleOk,
  color,
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_text_field, {
          modelValue: internalValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          color: color.value,
          messages: spareQtysMessages.value,
          label: `${__props.label}`,
          rules: [ruleOk],
          readonly: __props.readonly,
          onFocus: _cache[1] || (_cache[1] = ($event: any) => {inFocus.value = true; $event.target.select()}),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (inFocus.value = false)),
          inputmode: "decimal",
          variant: "underlined"
        }, {
          message: _withCtx(({ message }) => [
            (message !== ' ')
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  size: "small",
                  block: "",
                  class: "bg-primary text-white mt-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(message), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createVNode(_component_v_chip, {
              block: "",
              class: "mt-1 bg-grey-lighten-4 text-black",
              label: "",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, _toDisplayString(internalValueDisplay.value) + " " + _toDisplayString(__props.unit), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.spareQtys, (spareQty) => {
                    return (_openBlock(), _createElementBlock("span", { key: spareQty }, " + " + _toDisplayString(spareQty), 1))
                  }), 128))
                ])
              ], undefined, true),
              _: 1
            })
          ]),
          "append-inner": _withCtx(() => [
            (__props.qtyTotal)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.qtyTotal) + " " + _toDisplayString(__props.unit), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("b", _hoisted_5, [
                    (__props.max)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("/ " + _toDisplayString(__props.max), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("span", null, _toDisplayString(__props.unit), 1)
                  ])
                ])
              ], undefined, true),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "color", "messages", "label", "rules", "readonly"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_card_actions, { class: "qty-control-actions" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "qty-control-button rounded-0",
              disabled: internalValue.value < 1 || __props.readonly,
              style: {"flex":"auto"},
              elevation: "0",
              variant: "outlined",
              "selected-class": "text-primary",
              color: "primary",
              size: "large",
              cols: "12",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (internalValue.value -= 1))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-minus")
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_btn, {
              class: "qty-control-button rounded-0",
              elevation: "0",
              style: {"flex":"auto"},
              variant: !color.value ? 'outlined' : 'elevated',
              size: "large",
              cols: "12",
              color: color.value ?? 'primary',
              disabled: !canIncrease.value,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (internalValue.value += 1))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" mdi-plus ")
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }, 8, ["variant", "color", "disabled"])
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_v_card_subtitle, {
          style: {"line-height":"1.2","align-items":"flex-start"},
          class: "show-ean py-1 px-2 text-grey text-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (consistsOfDisplayed.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(consistsOfDisplayed.value), 1))
                : (_openBlock(), _createElementBlock("small", _hoisted_9, " "))
            ])
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}
}

})